import { Grid, TextField } from "@mui/material";
import UserCardUtils from "features/user/utils";

export interface UserData {
  dates?: {
    start?: Date | string;
    end?: Date | string;
  };
  streak?: number;
  bio?: string;
}

export interface UserCardBioProps {
  user: UserData;
}

const UserCardBio = ({ user }: UserCardBioProps) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const bioText = UserCardUtils.buildBioText({
    dates: user.dates as any,
    streak: user.streak,
    bio: user.bio,
  });

  return (
    <Grid
      container
      direction="column"
      spacing={1}
      sx={{ alignItems: "flex-end", p: 0.5, my: 1 }}
    >
      <TextField
        multiline
        disabled
        value={bioText}
        variant="standard"
        fullWidth
        InputProps={{
          disableUnderline: true,
          style: {
            fontSize: "0.75rem",
            color: "inherit",
            fontFamily: "inherit",
            lineHeight: "inherit",
          },
        }}
        sx={{
          "& .MuiInputBase-root": { padding: 0, margin: 0 },
          "& .MuiInputBase-input": { padding: 0, margin: 0, resize: "none" },
        }}
      />
    </Grid>
  );
};

export default UserCardBio;
